import { $ } from "@/common/Axios";

export default {
  /**
   * 教学计划
   */
  teachingProgram_changeEbook: {
    /*
     * 批量更换电子教材
     * ids 列表ids (array query required)
     * ebookId 电子教材id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/teachingProgram/changeEbook", p, c),
  },
  teachingProgram_changeCourse: {
    /*
     * 批量更换资源课程
     * ids 列表ids (array query required)
     * courseId 资源课程id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/teachingProgram/changeCourse", p, c),
  },
  teachingProgram: {
    /*
     * 添加
     * program  ( query required)
     */
    post: (p, c) => $.post("/api/ems/education/teachingProgram", p, c),

    /*
     * 删除
     * id 教学计划id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/education/teachingProgram", p, c),
  },
  teachingProgram_upload: {
    /*
     * 批量上传（如果名字改变视为新的教学计划）
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/education/teachingProgram/upload", p, c),
  },
  teachingProgram_uploadForCheck: {
    /*
     * 导入验证教学计划
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/teachingProgram/uploadForCheck", p, c),
  },
  teachingProgram_saveTextbook: {
    /*
     * 编辑教材
     * id 教学计划id (integer query required)
     * textbook 教材名称 (string query required)
     * bookSeller 书商 (string query required)
     * bookNo 书号 (string query required)
     * pressName 出版社 (string query required)
     * editor 主编 (string query required)
     * originPrice 原价 (number query required)
     * discount 折扣 (number query required)
     * price 折后价 (number query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/teachingProgram/saveTextbook", p, c),
  },
  teachingProgram_list: {
    /*
     * 教学计划列表
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/list", p, c),
  },
  teachingProgram_listTerm: {
    /*
     * 学期列表
     * rollGrade 学籍年级 (string query required)
     * majorId 专业id (integer query required)
     * currentTerm 当前学期 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/listTerm", p, c),
  },
  teachingProgram_listStudyRecordForCurrentTerm: {
    /*
     * 当前学期最近记录
     * rollGrade 学习年级 (string query required)
     * majorId 专业id (integer query required)
     * currentTerm 当前学期 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/teachingProgram/listStudyRecordForCurrentTerm",
        p,
        c
      ),
  },
  teachingProgram_listSimple: {
    /*
     * 简易列表
     * rollGrade 学籍年级 (string query )
     * majorId 专业id (integer query )
     * term 学期 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/listSimple", p, c),
  },
  teachingProgram_listSimpleWithMultiple: {
    /*
     * 简易列表
     * siteIds 学校列表 (array query )
     * majorIds 专业列表 (array query )
     * rollGrades 学籍年级列表 (array query )
     * terms 学期列表 (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listSimpleWithMultiple", p, c),
  },
  teachingProgram_listPlanByTerm: {
    /*
     * 每个学期的学习计划
     * rollGrade 学习年级 (string query required)
     * majorId 专业id (integer query required)
     * term 学期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listPlanByTerm", p, c),
  },
  teachingProgram_listForSiteAudit: {
    /*
     * 教学计划列表(审计)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listForSiteAudit", p, c),
  },
  teachingProgram_listCourseForCurrentTerm: {
    /*
     * 当前学期课程列表
     * rollGrade 学习年级 (string query required)
     * majorId 专业id (integer query required)
     * currentTerm 当前学期 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/teachingProgram/listCourseForCurrentTerm",
        p,
        c
      ),
  },
  teachingProgram_listBySchoolRollId: {
    /*
     * 根据合同编号查询教学计划列表,带电子书下载地址
     * schoolRollId 合同编号 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/listBySchoolRollId", p, c),
  },
  teachingProgram_export: {
    /*
     * 教学计划导出
     */
    get: (p, c) => $.get("/api/ems/education/teachingProgram/export", p, c),
  },
  teachingProgram_exportForSiteAudit: {
    /*
     * 教学计划导出(审计)
     */
    get: (p, c) =>
      $.get("/api/ems/education/teachingProgram/exportForSiteAudit", p, c),
  },
  teachingProgram_batchRemove: {
    /*
     * 批量删除教学计划
     * ids 教学计划id列表 (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/teachingProgram/batchRemove", p, c),
  },

  /**
   * 合同（学籍）异动
   */
  schoolRollTransaction_uploadEduFile: {
    /*
     * 教务上传退学时的文件
     * id id (integer query required)
     * eduFile 退学时教务上传的文件 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/uploadEduFile", p, c),
  },
  schoolRollTransaction_eduEdit: {
    /*
     * 编辑办结
     * id id (integer query required)
     * receivedPaper 是否收到纸质稿 (string query required)
     * schoolFinished 高校手续是否办结 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/eduEdit", p, c),
  },
  schoolRollTransaction_editExtraFile: {
    /*
     * 编辑附件
     * id id (integer query required)
     * extraFile 附件 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/editExtraFile", p, c),
  },
  schoolRollTransaction_checkNeedPayFee: {
    /*
     * 检测转批次是否需要缴费
     * schoolRollId schoolRollId (integer query required)
     * newBatch 新批次 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollTransaction/checkNeedPayFee", p, c),
  },
  schoolRollTransaction_batchLeave: {
    /*
     * 批量不读
     * schoolRollIds 学籍id (array query required)
     * applyRemark 备注 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollTransaction/batchLeave", p, c),
  },
  schoolRollTransaction_applyForEnroll: {
    /*
     * 招办异动申请
     * schoolRollId 学籍id (integer query required)
     * tradeType 异动类型：不读，转校转专业，转批次 (string query required)
     * majorId 专业id (integer query )
     * batch 批次 (string query )
     * extraFile 附件 (string query )
     * accountType 账号类型 (string query )
     * accountNick 账号昵称 (string query )
     * account 账号 (string query )
     * applyRemark 备注 (string query )
     * amount 不读退款金额 (number query )
     * dropoutsExtraFile 退学视频附件 (string query )
     * giveUpReason 不读理由，职教下拉 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollTransaction/applyForEnroll", p, c),
  },
  schoolRollTransaction_applyForEducation: {
    /*
     * 教务异动申请
     * schoolRollId 学籍id (integer query required)
     * tradeType 异动类型：休学、退学、转专业、复学, 转批次(自考特有) (string query required)
     * majorId 专业id (integer query )
     * rollGrade 学籍年级 (string query )
     * endTime 休学结束时间 (string query )
     * reason 异动理由 (string query )
     * extraFile 附件 (string query )
     * dropoutsExtraFile 退学视频附件 (string query )
     * applyRemark 备注 (string query )
     * batch 新批次, 转批次才有 (string query )
     * giveUpReason 退学原因，自考下拉 (string query )
     * adultExitFlag 成教合同是否退学（继教院退学时候选择） (string query )
     * orderNo 订单编号：升降班使用 (string query )
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollTransaction/applyForEducation",
        p,
        c
      ),
  },
  schoolRollTransaction_listSimple: {
    /*
     * 简易异动列表
     * schoolRollId 学籍id (integer query required)
     * type 类型：招办异动，教务异动 (string query required)
     * tradeType 具体类型 (string query )
     * status 审批状态:通过 审核中 拒绝 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listSimple", p, c),
  },
  schoolRollTransaction_listPageForEnroll: {
    /*
     * 招办异动记录列表-招办管理-学历教育
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listPageForEnroll", p, c),
  },
  schoolRollTransaction_listPageForEnrollForPeer: {
    /*
     * 招办异动记录列表-基础平台-同行管理-招办异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/listPageForEnrollForPeer",
        p,
        c
      ),
  },
  schoolRollTransaction_listPageForEdu: {
    /*
     * 教务异动记录列表-学籍管理-学历教育
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listPageForEdu", p, c),
  },
  schoolRollTransaction_listPageForEduForPeer: {
    /*
     * 教务异动记录列表-基础平台-同行管理-教务异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/listPageForEduForPeer",
        p,
        c
      ),
  },
  schoolRollTransaction_listForSiteAudit: {
    /*
     * 异动记录（学校审计）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listForSiteAudit", p, c),
  },
  schoolRollTransaction_listDoing: {
    /*
     * 进行中异动
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/listDoing", p, c),
  },
  schoolRollTransaction_getBatchAmount: {
    /*
     * 获取转批次金额
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/getBatchAmount", p, c),
  },
  schoolRollTransaction_exportPageForEnroll: {
    /*
     * 招办异动记录列表导出-招办管理-学历教育
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/exportPageForEnroll",
        p,
        c
      ),
  },
  schoolRollTransaction_exportPageForEnrollForPeer: {
    /*
     * 招办异动记录列表导出-基础平台-同行管理-招办异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/exportPageForEnrollForPeer",
        p,
        c
      ),
  },
  schoolRollTransaction_exportPageForEdu: {
    /*
     * 教务异动记录列表导出-学籍管理-学历教育
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/exportPageForEdu", p, c),
  },
  schoolRollTransaction_exportPageForEduForPeer: {
    /*
     * 教务异动记录列表导出-基础平台-同行管理-教务异动记录
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/exportPageForEduForPeer",
        p,
        c
      ),
  },
  schoolRollTransaction_exportForSiteAudit: {
    /*
     * 异动记录导出（学校审计）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollTransaction/exportForSiteAudit",
        p,
        c
      ),
  },
  schoolRollTransaction_exportForDoing: {
    /*
     * 异动审核列表导出-内部管理-基础平台
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/exportForDoing", p, c),
  },
  schoolRollTransaction_downloadMould: {
    /*
     * 批量异动模版下载
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/downloadMould", p, c),
  },
  schoolRollTransaction_details: {
    /*
     * 详情
     * id id (integer query required)
     * getMoney 是否获取返款金额和优惠等, 异动类型为不读的时候传1 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollTransaction/details", p, c),
  },

  /**
   * 技能培训合同信息
   */
  schoolRollSkillTrain_editForService: {
    /*
     * 后端编辑
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSkillTrain/editForService", p, c),
  },
  schoolRollSkillTrain_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSkillTrain/editForFront", p, c),
  },
  schoolRollSkillTrain_listForService: {
    /*
     * 服务列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSkillTrain/listForService", p, c),
  },
  schoolRollSkillTrain_listForAudit: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSkillTrain/listForAudit", p, c),
  },
  schoolRollSkillTrain_exportForService: {
    /*
     * 服务列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSkillTrain/exportForService", p, c),
  },
  schoolRollSkillTrain_exportForAudit: {
    /*
     * 招办审核导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSkillTrain/exportForAudit", p, c),
  },
  schoolRollSkillTrain_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSkillTrain/detailsForService", p, c),
  },
  schoolRollSkillTrain_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSkillTrain/detailsForFront", p, c),
  },

  /**
   * 合同自考信息表
   */
  schoolRollSelfTaught_updateContinueFlag: {
    /*
     * undefined
     * schoolRollId 合同id (integer query required)
     * continueFlag 是否职教生 (string query required)
     * continueSchoolRollId 职教合同编号 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSelfTaught/updateContinueFlag", p, c),
  },
  schoolRollSelfTaught_syncContinueFlag: {
    /*
     * 同步是否职教生
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSelfTaught/syncContinueFlag", p, c),
  },
  schoolRollSelfTaught_editForService: {
    /*
     * 后端编辑
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSelfTaught/editForService", p, c),
  },
  schoolRollSelfTaught_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计、招办审核）
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollSelfTaught/editForFront", p, c),
  },
  schoolRollSelfTaught_uploadRegister: {
    /*
     * 批量导入自考电子注册备案表(学信网截图)-毕业学生
     * id id (integer query required)
     * url url (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollSelfTaught/uploadRegister", p, c),
  },
  schoolRollSelfTaught_uploadRegisterUrl: {
    /*
     * 导入毕业登记表-预毕业
     * id id (integer query required)
     * url url (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollSelfTaught/uploadRegisterUrl", p, c),
  },
  schoolRollSelfTaught_uploadGraduateTime: {
    /*
     * 批量导入毕业时间
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollSelfTaught/uploadGraduateTime",
        p,
        c
      ),
  },
  schoolRollSelfTaught_uploadDiploma: {
    /*
     * 批量导入毕业证-毕业学生
     * id id (integer query required)
     * url url (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollSelfTaught/uploadDiploma", p, c),
  },
  schoolRollSelfTaught_listUnfinishCourse: {
    /*
     * 未完成课程列表
     * schoolRollId 合同id (integer query required)
     * courseType 课程类型：必修课程、公共课程 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listUnfinishCourse", p, c),
  },
  schoolRollSelfTaught_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listUnAssign", p, c),
  },
  schoolRollSelfTaught_listGraduate: {
    /*
     * 毕业学生-列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listGraduate", p, c),
  },
  schoolRollSelfTaught_listForTeacher: {
    /*
     * 自考学生列表（讲师）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listForTeacher", p, c),
  },
  schoolRollSelfTaught_listForService: {
    /*
     * 服务学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listForService", p, c),
  },
  schoolRollSelfTaught_listForAudit: {
    /*
     * 资料审核列表（自考）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listForAudit", p, c),
  },
  schoolRollSelfTaught_listCredit: {
    /*
     * 学分列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/listCredit", p, c),
  },
  schoolRollSelfTaught_exportGraduate: {
    /*
     * 毕业学生-导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportGraduate", p, c),
  },
  schoolRollSelfTaught_exportForTeacher: {
    /*
     * 自考学生列表（讲师）导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportForTeacher", p, c),
  },
  schoolRollSelfTaught_exportForService: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportForService", p, c),
  },
  schoolRollSelfTaught_exportForAudit: {
    /*
     * 资料审核列表导出（自考）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportForAudit", p, c),
  },
  schoolRollSelfTaught_exportCredit: {
    /*
     * 学分列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/exportCredit", p, c),
  },
  schoolRollSelfTaught_downloadGraduateTimeMould: {
    /*
     * 下载批量导入毕业时间模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollSelfTaught/downloadGraduateTimeMould",
        p,
        c
      ),
  },
  schoolRollSelfTaught_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/detailsForService", p, c),
  },
  schoolRollSelfTaught_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollSelfTaught/detailsForFront", p, c),
  },

  /**
   * 新生注册
   */
  schoolRollRegistry_refuse: {
    /*
     * 班主任打回新生注册信息
     * id ID (integer query required)
     * refuseReason 打回理由 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollRegistry/refuse", p, c),
  },
  schoolRollRegistry_eduRefuse: {
    /*
     * 教务打回
     * id ID (integer query required)
     * refuseReason 打回理由 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/eduRefuse", p, c),
  },
  schoolRollRegistry_eduDispose: {
    /*
     * 教务处理反馈错误
     * id ID (integer query required)
     * resultContent 处理内容 (string query required)
     * extraUrl 处理附件 (string query )
     * finishStatus 状态：未完结|已完结 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/eduDispose", p, c),
  },
  schoolRollRegistry_confirmForManager: {
    /*
     * 班主任确认新生注册信息
     * id ID (integer query )
     * schoolRollId schoolRollId (integer query required)
     * chsiImage 学信网截图 (string query required)
     * confirmStatus 确认状态，已确认|反馈错误 (string query required)
     * reportReason 反馈错误描述 (string query )
     * reportExtraUrl 反馈错误附件 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/confirmForManager", p, c),
  },
  schoolRollRegistry_confirmForClient: {
    /*
     * 学生确认或编辑（被打回）新生注册信息
     * id 新生注册信息返回的ID (integer query )
     * chsiImage 学信网截图 (string query required)
     * confirmStatus 确认状态，已确认|反馈错误 (string query required)
     * reportReason 反馈错误描述 (string query )
     * reportExtraUrl 反馈错误附件 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollRegistry/confirmForClient", p, c),
  },
  schoolRollRegistry_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollRegistry/list", p, c),
  },
  schoolRollRegistry_listEduDispose: {
    /*
     * 教务处理记录
     * id ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollRegistry/listEduDispose", p, c),
  },
  schoolRollRegistry_infoForClient: {
    /*
     * 学生获取新生注册信息
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollRegistry/infoForClient", p, c),
  },
  schoolRollRegistry_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollRegistry/export", p, c),
  },
  schoolRollRegistry_details: {
    /*
     * 详情
     * schoolRollId 合同编号 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollRegistry/details", p, c),
  },
  schoolRollRegistry_countUnFinishedForMainPage: {
    /*
     * 未进行学籍核对数量
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollRegistry/countUnFinishedForMainPage",
        p,
        c
      ),
  },

  /**
   * 学生信息勘误
   */
  schoolRollInfoModify_update: {
    /*
     * 编辑
     * id id (integer query required)
     * newName 新学生姓名 (string query )
     * newIdCardNo 新身份证号 (string query )
     * newIdCardFrontPhoto 新身份证正面照片 (string query )
     * newIdCardBackPhoto 新身份证背面照片 (string query )
     * newNation 新民族 (string query )
     * newPoliticalStatus 新政治面貌 (string query )
     * remark 申请备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollInfoModify/update", p, c),
  },
  schoolRollInfoModify_finish: {
    /*
     * 办结
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollInfoModify/finish", p, c),
  },
  schoolRollInfoModify_apply: {
    /*
     * 申请（服务-学生详情-在读状态）
     * schoolRollId schoolRollId (integer query )
     * newName 新学生姓名 (string query )
     * newIdCardNo 新身份证号 (string query )
     * newIdCardFrontPhoto 新身份证正面照片 (string query )
     * newIdCardBackPhoto 新身份证背面照片 (string query )
     * newNation 新民族 (string query )
     * newPoliticalStatus 新政治面貌 (string query )
     * remark 申请备注 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollInfoModify/apply", p, c),
  },
  schoolRollInfoModify_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollInfoModify/list", p, c),
  },
  schoolRollInfoModify_listSimple: {
    /*
     * 简易列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollInfoModify/listSimple", p, c),
  },
  schoolRollInfoModify_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollInfoModify/details", p, c),
  },

  /**
   * GEO平台合同信息
   */
  schoolRollGeo_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计
     * student  ( query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollGeo/editForFront", p, c),
  },
  schoolRollGeo_listForAudit: {
    /*
     * 招办审核列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollGeo/listForAudit", p, c),
  },
  schoolRollGeo_exportForAudit: {
    /*
     * 招办审核导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollGeo/exportForAudit", p, c),
  },
  schoolRollGeo_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollGeo/detailsForFront", p, c),
  },

  /**
   * 档案存储合同信息
   */
  schoolRollDoc_editForService: {
    /*
     * 后端编辑
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollDoc/editForService", p, c),
  },
  schoolRollDoc_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计
     * student  ( query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollDoc/editForFront", p, c),
  },
  schoolRollDoc_batchUpdateSaveStatus: {
    /*
     * 批量更新存储状态
     * schoolRollIds 学籍id (array query required)
     * saveStatus 存储状态 (string query required)
     * saveTime 存储时间 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollDoc/batchUpdateSaveStatus", p, c),
  },
  schoolRollDoc_associationFatherSchoolRollId: {
    /*
     * 关联父合同编号
     * schoolRollId 学籍id (integer query required)
     * fatherSchoolRollId 父合同编号 (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollDoc/associationFatherSchoolRollId",
        p,
        c
      ),
  },
  schoolRollDoc_uploadForService: {
    /*
     * 服务列表导入
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollDoc/uploadForService", p, c),
  },
  schoolRollDoc_listForService: {
    /*
     * 服务列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollDoc/listForService", p, c),
  },
  schoolRollDoc_getDocIdBySchoolRollId: {
    /*
     * 根据学籍id获取档案合同id
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollDoc/getDocIdBySchoolRollId", p, c),
  },
  schoolRollDoc_exportForService: {
    /*
     * 服务列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollDoc/exportForService", p, c),
  },
  schoolRollDoc_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollDoc/detailsForService", p, c),
  },
  schoolRollDoc_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollDoc/detailsForFront", p, c),
  },

  /**
   * 继教院合同信息
   */
  schoolRollContinue_uploadContinueNoticeConfirm: {
    /*
     * 上传继教院告知书
     * id id (integer query required)
     * agreementUrl 报读地址 (string query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/uploadContinueNoticeConfirm",
        p,
        c
      ),
  },
  schoolRollContinue_uploadContinueNoticeConfirmForClient: {
    /*
     * C端上传告知书（学生签名）
     * id id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/uploadContinueNoticeConfirmForClient",
        p,
        c
      ),
  },
  schoolRollContinue_updateSchoolingStatus: {
    /*
     * 单个更新在读状态
     * schoolRollId 学籍id (integer query required)
     * enterSchoolDate 报道时间 (string query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/updateSchoolingStatus",
        p,
        c
      ),
  },
  schoolRollContinue_updateInterviewStatus: {
    /*
     * 更新面试状态
     * schoolRollId 合同id (integer query required)
     * interviewStatus 面试状态 (string query required)
     * interviewTime 面试时间 (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/updateInterviewStatus",
        p,
        c
      ),
  },
  schoolRollContinue_updateEnrollByOtherStation: {
    /*
     * 学历是否已报他处
     * schoolRollId 合同编号 (integer query required)
     * enrollByOtherStation 是否 (string query required)
     * enrollByOtherStationUrl 已报他处凭证 (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/updateEnrollByOtherStation",
        p,
        c
      ),
  },
  schoolRollContinue_graduate: {
    /*
     * 批量毕业
     * schoolRollIds 合同id (array query required)
     * graduateTime 毕业时间 (string query required)
     * adultHeaderTeacherId 成教班主任 (integer query )
     * selfTaughtHeaderTeacherId 自考班主任 (integer query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/graduate", p, c),
  },
  schoolRollContinue_editForService: {
    /*
     * 后端编辑
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/editForService", p, c),
  },
  schoolRollContinue_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计、招办审核）
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/editForFront", p, c),
  },
  schoolRollContinue_clearDormitory: {
    /*
     * 清空寝室
     * schoolRollIds 合同id (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/clearDormitory", p, c),
  },
  schoolRollContinue_changeIgnoreAdultType: {
    /*
     * 修改未报成教类型
     * schoolRollId 合同id (integer query required)
     * ignoreAdultType 未报成教类型 (string query required)
     * ignoreAdultReason 未报成教理由 (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRollContinue/changeIgnoreAdultType",
        p,
        c
      ),
  },
  schoolRollContinue_assignDormitory: {
    /*
     * 分配寝室
     * schoolRollIds 合同id (array query required)
     * bedroomId 宿舍id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/assignDormitory", p, c),
  },
  schoolRollContinue_assignClassRoom: {
    /*
     * 分班
     * schoolRollIds 合同id (array query required)
     * classRoomId 班级id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollContinue/assignClassRoom", p, c),
  },
  schoolRollContinue_uploadSomeInfoForContinue: {
    /*
     * 继教院-批量导入修改信息
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollContinue/uploadSomeInfoForContinue",
        p,
        c
      ),
  },
  schoolRollContinue_uploadSchooling: {
    /*
     * 批量导入在读名单
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/uploadSchooling", p, c),
  },
  schoolRollContinue_uploadGraduate: {
    /*
     * 批量导入毕业名单
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/uploadGraduate", p, c),
  },
  schoolRollContinue_uploadForCont: {
    /*
     * 导入(职教学校平台)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/uploadForCont", p, c),
  },
  schoolRollContinue_uploadEnroll: {
    /*
     * 继教院-批量导入合同
     * batch 批次，未传取配置[继教院当前批次] (string query )
     * sourceFrom 来源详情：线上、线下，默认线下 (string query )
     * sourceFromDetail 具体来源详情 (string query )
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/uploadEnroll", p, c),
  },
  schoolRollContinue_uploadChangeDormitory: {
    /*
     * 导入更换寝室
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollContinue/uploadChangeDormitory",
        p,
        c
      ),
  },
  schoolRollContinue_refreshAdultInfo: {
    /*
     * 单个刷新成教信息
     * schoolRollId 合同id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/refreshAdultInfo", p, c),
  },
  schoolRollContinue_initServer: {
    /*
     * 初始化服务端数据
     * enrollTeacherId 招生老师id (integer query )
     * batch 批次 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/initServer", p, c),
  },
  schoolRollContinue_batchRefreshAdultInfo: {
    /*
     * 批量刷新成教信息
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollContinue/batchRefreshAdultInfo",
        p,
        c
      ),
  },
  schoolRollContinue_addForCont: {
    /*
     * 新增(职教学校平台)
     * name 姓名 (string query required)
     * idCardNo 身份证 (string query required)
     * classRoomId 班级id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollContinue/addForCont", p, c),
  },
  schoolRollContinue_searchEnrollInfo: {
    /*
     * 查询职教合同录取情况
     * siteId 学校id：江财1783772064219987969 (integer query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/searchEnrollInfo", p, c),
  },
  schoolRollContinue_parentSignInInfo: {
    /*
     * 家长登录情况
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/parentSignInInfo", p, c),
  },
  schoolRollContinue_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listUnAssign", p, c),
  },
  schoolRollContinue_listTransaction: {
    /*
     * 异动列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listTransaction", p, c),
  },
  schoolRollContinue_listStudentForTeacher: {
    /*
     * 学生列表(讲师)
     * classRoomId 班级id (string query required)
     * name 姓名 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/listStudentForTeacher",
        p,
        c
      ),
  },
  schoolRollContinue_listStudentForChargeSite: {
    /*
     * 根据负责的学校和姓名获取学生列表
     * siteId 学校id (integer query required)
     * classRoomId 班级id (integer query )
     * bedroomId 宿舍id (integer query )
     * name 姓名 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/listStudentForChargeSite",
        p,
        c
      ),
  },
  schoolRollContinue_listSimpleStudent: {
    /*
     * 根据是否自考生查询某班级学生列表
     * classRoomIds 班级ids (array query required)
     * type 类型：自考生1、非自考生2,全部则不传 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listSimpleStudent", p, c),
  },
  schoolRollContinue_listForService: {
    /*
     * 服务学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listForService", p, c),
  },
  schoolRollContinue_listForCont: {
    /*
     * 列表(职教学校平台)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listForCont", p, c),
  },
  schoolRollContinue_listForAudit: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listForAudit", p, c),
  },
  schoolRollContinue_listAdultEnrollInfo: {
    /*
     * 获取成教录取信息
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/listAdultEnrollInfo", p, c),
  },
  schoolRollContinue_getContinueNoticeConfirmInfo: {
    /*
     * 获取继教院告知书内容
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/getContinueNoticeConfirmInfo",
        p,
        c
      ),
  },
  schoolRollContinue_exportTransaction: {
    /*
     * 异动列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportTransaction", p, c),
  },
  schoolRollContinue_exportForService: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportForService", p, c),
  },
  schoolRollContinue_exportForCont: {
    /*
     * 导出(职教学校平台)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportForCont", p, c),
  },
  schoolRollContinue_exportForAudit: {
    /*
     * 招办审核导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/exportForAudit", p, c),
  },
  schoolRollContinue_downloadSomeInfoForContinueMould: {
    /*
     * 继教院-下载继教院批次修改信息模板
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/downloadSomeInfoForContinueMould",
        p,
        c
      ),
  },
  schoolRollContinue_downloadSchoolingModule: {
    /*
     * 继教院-下载批量导入在读名单模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/downloadSchoolingModule",
        p,
        c
      ),
  },
  schoolRollContinue_downloadGraduateModule: {
    /*
     * 继教院-下载批量导入毕业名单模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/downloadGraduateModule",
        p,
        c
      ),
  },
  schoolRollContinue_downloadEnrollModule: {
    /*
     * 继教院-下载批量导入合同模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/downloadEnrollModule", p, c),
  },
  schoolRollContinue_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/detailsForService", p, c),
  },
  schoolRollContinue_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/detailsForFront", p, c),
  },
  schoolRollContinue_countUnfinishParentContact: {
    /*
     * 获取未完成联系家长次数（两次）数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollContinue/countUnfinishParentContact",
        p,
        c
      ),
  },
  schoolRollContinue_countUnfinishContact: {
    /*
     * 获取未完成联系学生次数（1次）数量
     * headerTeacherId 班主任id (integer query )
     * siteIds 学校id (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollContinue/countUnfinishContact", p, c),
  },
  schoolRollContinue_removeForCont: {
    /*
     * 删除(职教学校平台)
     * schoolRollId 合同id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/schoolRollContinue/removeForCont", p, c),
  },

  /**
   * AIGC平台合同信息
   */
  schoolRollAigc_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAigc/editForFront", p, c),
  },
  schoolRollAigc_assignHeaderTeacher: {
    /*
     * 分配班主任（服务学生）
     * ids 服务信息id (array query required)
     * headerTeacherId 班主任id (integer query required)
     * syncWechat 企微学生是否同步移交 (string query )
     * message 移交企微时发送给学生的消息 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAigc/assignHeaderTeacher", p, c),
  },
  schoolRollAigc_assignClass: {
    /*
     * 分班（服务学生）
     * ids 服务信息id (array query required)
     * classRoomId 班级id，不传或传0表示取消分班 (integer query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollAigc/assignClass", p, c),
  },
  schoolRollAigc_listForService: {
    /*
     * 服务学生列表（班主任及其所在部门/上级部门负责人可见）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAigc/listForService", p, c),
  },
  schoolRollAigc_listForAudit: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAigc/listForAudit", p, c),
  },
  schoolRollAigc_exportForService: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAigc/exportForService", p, c),
  },
  schoolRollAigc_exportForAudit: {
    /*
     * 招办审核导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAigc/exportForAudit", p, c),
  },
  schoolRollAigc_detailsForService: {
    /*
     * 服务学生详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAigc/detailsForService", p, c),
  },
  schoolRollAigc_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAigc/detailsForFront", p, c),
  },

  /**
   * 成教培训合同信息
   */
  schoolRollAdultTrain_edit: {
    /*
     * 编辑
     * schoolRollId 合同编号 (integer query required)
     * majorId 专业id (integer query required)
     * fatherSchoolRollId 父合同编号 (integer query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollAdultTrain/edit", p, c),
  },
  schoolRollAdultTrain_upload: {
    /*
     * 上传
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdultTrain/upload", p, c),
  },
  schoolRollAdultTrain_uploadAdultTrainConfig: {
    /*
     * 导入成教培训配置
     * file  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollAdultTrain/uploadAdultTrainConfig",
        p,
        c
      ),
  },
  schoolRollAdultTrain_setAdultTrainConfig: {
    /*
     * 设置成教培训配置
     * config  ( query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollAdultTrain/setAdultTrainConfig",
        p,
        c
      ),
  },
  schoolRollAdultTrain_refresh: {
    /*
     * 刷新数据
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdultTrain/refresh", p, c),
  },
  schoolRollAdultTrain_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollAdultTrain/list", p, c),
  },
  schoolRollAdultTrain_getAdultTrainConfig: {
    /*
     * 获取成教培训配置
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdultTrain/getAdultTrainConfig",
        p,
        c
      ),
  },
  schoolRollAdultTrain_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdultTrain/export", p, c),
  },
  schoolRollAdultTrain_exportAdultTrainConfig: {
    /*
     * 导出成教培训配置
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdultTrain/exportAdultTrainConfig",
        p,
        c
      ),
  },

  /**
   * 学历合同信息
   */
  schoolRollAdult_updateEducation: {
    /*
     * 编辑教务学生
     * id 学籍id (integer query required)
     * name 姓名 (string query )
     * idCardNo 身份证 (string query )
     * idCardType 证件类型，不传视为身份证 (string query )
     * idCardFrontPhoto 身份证正面 (string query )
     * idCardBackPhoto 身份证背面 (string query )
     * nation 民族 (string query )
     * studentNo 学号 (string query )
     * studentExamNo 考生号 (string query )
     * rollGrade 学籍年级 (string query )
     * realGraduateTime 毕业时间 (string query )
     * eduRemark 教务备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateEducation", p, c),
  },
  schoolRollAdult_updateEducationWarning: {
    /*
     * 更新学籍到期和预警时间
     * siteType 学校类型 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateEducationWarning", p, c),
  },
  schoolRollAdult_updateByService: {
    /*
     * 服务学生编辑
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByService", p, c),
  },
  schoolRollAdult_updateByEnroll: {
    /*
     * 招生老师编辑
     * schoolRoll  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByEnroll", p, c),
  },
  schoolRollAdult_updateByEnrollEducation: {
    /*
     * 招办老师编辑
     * schoolRoll  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByEnrollEducation", p, c),
  },
  schoolRollAdult_updateByClient: {
    /*
     * C端学生查看编辑, 招生老师审核中的方可编辑
     * schoolRoll  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRollAdult/updateByClient", p, c),
  },
  schoolRollAdult_admission: {
    /*
     * 录取
     * id 合同id (integer query required)
     * studentExamNo 考生号 (string query )
     * studentNo 学号 (string query )
     * contractId 所属站点id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRollAdult/admission", p, c),
  },
  schoolRollAdult_uploadSpecialStudent: {
    /*
     * 批量导入特殊学生
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadSpecialStudent", p, c),
  },
  schoolRollAdult_uploadPhotoCollection: {
    /*
     * 导入毕业照片采集地
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadPhotoCollection", p, c),
  },
  schoolRollAdult_uploadEducation: {
    /*
     * 导入教务学生
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadEducation", p, c),
  },
  schoolRollAdult_uploadCampusOrEnterprisePoint: {
    /*
     * 导入更新期末考区或校企学生期末考点
     * type 导入类型:期末考区|企业学生期末考点 (string query required)
     * clearFlag 导入考区时是否清空企业学生期末考点 (string query )
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollAdult/uploadCampusOrEnterprisePoint",
        p,
        c
      ),
  },
  schoolRollAdult_uploadAdmission: {
    /*
     * 导入录取名单
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadAdmission", p, c),
  },
  schoolRollAdult_uploadAdmissionLetter: {
    /*
     * 导入录取通知书
     * batch 批次 (string query required)
     * idCardNo 身份证号 (string query required)
     * url 地址 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollAdult/uploadAdmissionLetter", p, c),
  },
  schoolRollAdult_saveStudentCategoryConfig: {
    /*
     * 保存成教学生分类权限配置
     * configKey key：成教学生分类审核（分配，查看）权限 (string query required)
     * content json内容 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollAdult/saveStudentCategoryConfig",
        p,
        c
      ),
  },
  schoolRollAdult_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listUnAssign", p, c),
  },
  schoolRollAdult_listStudent: {
    /*
     * 服务学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listStudent", p, c),
  },
  schoolRollAdult_listForSiteAudit: {
    /*
     * 教务学生列表(审计)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForSiteAudit", p, c),
  },
  schoolRollAdult_listForServiceWarning: {
    /*
     * 学籍预警学生列表(服务)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForServiceWarning", p, c),
  },
  schoolRollAdult_listForEnroll: {
    /*
     * 招办学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEnroll", p, c),
  },
  schoolRollAdult_listForEducation: {
    /*
     * 教务学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEducation", p, c),
  },
  schoolRollAdult_listForEducationWarning: {
    /*
     * 学籍预警学生列表(教务)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEducationWarning", p, c),
  },
  schoolRollAdult_listForEducationConfirm: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/listForEducationConfirm", p, c),
  },
  schoolRollAdult_getStudentCategoryConfig: {
    /*
     * 成教学生分类查看权限
     * configKey key：成教学生分类审核（分配，查看）权限 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/getStudentCategoryConfig",
        p,
        c
      ),
  },
  schoolRollAdult_getAdmissionLetterForClient: {
    /*
     * C端查询录取通知书-园丁
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/getAdmissionLetterForClient",
        p,
        c
      ),
  },
  schoolRollAdult_exportStudent: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportStudent", p, c),
  },
  schoolRollAdult_exportForSiteAudit: {
    /*
     * 教务学生列表(审计)导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportForSiteAudit", p, c),
  },
  schoolRollAdult_exportForServiceWarning: {
    /*
     * 学籍预警学生列表导出(服务)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportForServiceWarning", p, c),
  },
  schoolRollAdult_exportForEnroll: {
    /*
     * 招办学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportForEnroll", p, c),
  },
  schoolRollAdult_exportForEducation: {
    /*
     * 教务学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/exportForEducation", p, c),
  },
  schoolRollAdult_exportForEducationWarning: {
    /*
     * 学籍预警学生列表导出(教务)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/exportForEducationWarning",
        p,
        c
      ),
  },
  schoolRollAdult_exportForEducationConfirm: {
    /*
     * 招办审核列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/exportForEducationConfirm",
        p,
        c
      ),
  },
  schoolRollAdult_downloadSpecialStudentMould: {
    /*
     * 下载导入特殊学生模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/downloadSpecialStudentMould",
        p,
        c
      ),
  },
  schoolRollAdult_downloadMouldForCampusOrEnterprisePoint: {
    /*
     * 期末考区或校企学生期末考点导入模板
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/downloadMouldForCampusOrEnterprisePoint",
        p,
        c
      ),
  },
  schoolRollAdult_downloadEducationMould: {
    /*
     * 下载教务学生模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/downloadEducationMould", p, c),
  },
  schoolRollAdult_downloadAdmissionMould: {
    /*
     * 下载录取名单模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/downloadAdmissionMould", p, c),
  },
  schoolRollAdult_detailsForService: {
    /*
     * 学籍合同详情
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/detailsForService", p, c),
  },
  schoolRollAdult_detailsForFront: {
    /*
     * 前端学籍合同详情（报名确认、招生统计、招办审核、招办学生）--成教远程国开
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/detailsForFront", p, c),
  },
  schoolRollAdult_detailsForFrontForClient: {
    /*
     * 前端学籍合同详情-C端学生查看编辑
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollAdult/detailsForFrontForClient",
        p,
        c
      ),
  },
  schoolRollAdult_detailsForEducation: {
    /*
     * 教务学生详情
     * id 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollAdult/detailsForEducation", p, c),
  },

  /**
   * 学生合同学籍表
   */
  schoolRoll_uploadFrontAgreement: {
    /*
     * 上传录取前报读须知
     * id id (integer query required)
     * agreementUrl 报读地址 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/uploadFrontAgreement", p, c),
  },
  schoolRoll_uploadFrontAgreementForClient: {
    /*
     * C端上传录取前报读须知（学生签名）
     * id id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRoll/uploadFrontAgreementForClient",
        p,
        c
      ),
  },
  schoolRoll_uploadAgreement: {
    /*
     * 上传正式报读协议
     * id id (integer query required)
     * agreementUrl 报读协议地址 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/uploadAgreement", p, c),
  },
  schoolRoll_uploadAgreementForClient: {
    /*
     * C端上传正式报读协议（学生签名）
     * id id (integer query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/uploadAgreementForClient", p, c),
  },
  schoolRoll_updateForSuspend: {
    /*
     * 编辑单个休学学生
     * id 学籍id (integer query required)
     * suspendEnd 休学结束时间 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/updateForSuspend", p, c),
  },
  schoolRoll_updateByService: {
    /*
     * 服务老师编辑
     * schoolRoll  ( query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/updateByService", p, c),
  },
  schoolRoll_updateByEnroll: {
    /*
     * 招生老师编辑
     * schoolRoll  ( query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/updateByEnroll", p, c),
  },
  schoolRoll_updateByEducation: {
    /*
     * 招办老师编辑
     * schoolRoll  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/updateByEducation", p, c),
  },
  schoolRoll_transferAdminTeacher: {
    /*
     * 移交合同负责人
     * adminTeacherId 原合同负责人 (integer query required)
     * newAdminTeacherId 新合同负责人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/transferAdminTeacher", p, c),
  },
  schoolRoll_startSchoolRollByFirstFee: {
    /*
     * 合同开始（初次缴费成功）
     * id 学籍id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/startSchoolRollByFirstFee", p, c),
  },
  schoolRoll_saveAdminRemark: {
    /*
     * 添加备注（合同负责人）
     * id 合同id (integer query required)
     * content 内容 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/saveAdminRemark", p, c),
  },
  schoolRoll_removeFrontAgreement: {
    /*
     * 删除录取前报读须知
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/removeFrontAgreement", p, c),
  },
  schoolRoll_removeAgreement: {
    /*
     * 删除正式报读协议
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/removeAgreement", p, c),
  },
  schoolRoll_remarkByEnroll: {
    /*
     * 招生备注
     * id id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/remarkByEnroll", p, c),
  },
  schoolRoll_passByEnrollTeacher: {
    /*
     * 招生老师通过
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/passByEnrollTeacher", p, c),
  },
  schoolRoll_passByEducation: {
    /*
     * 教务审核通过
     * id id (integer query required)
     * headerTeacherId 班主任ID, 自考/免试专升本/继教院/中职高复/AIGC平台审核时必填，通过后自动分配该班主任 (integer query )
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/passByEducation", p, c),
  },
  schoolRoll_exemptionDegree_updateEnrollSiteAndResult: {
    /*
     * 编辑录取结果录取院校等
     * id 合同编号 (integer query required)
     * enrollResult key录取结果 (string query required)
     * enrollSiteId 录取院校, 下拉, exemptionDegreeSite下的简易列表, 默认浙江省 (integer query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRoll/exemptionDegree/updateEnrollSiteAndResult",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_editForService: {
    /*
     * 后端编辑
     * student  ( query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/schoolRoll/exemptionDegree/editForService",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_editForFront: {
    /*
     * 前端编辑（报名确认、招生统计、招办审核）
     * student  ( query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/exemptionDegree/editForFront", p, c),
  },
  schoolRoll_endSchoolRollByFullPayment: {
    /*
     * 合同完成（缴完全款）
     * id 学籍id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/endSchoolRollByFullPayment", p, c),
  },
  schoolRoll_divideEnrollTeacher: {
    /*
     * 划分业绩
     * id id (integer query required)
     * enrollTeacherId 招生老师id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/divideEnrollTeacher", p, c),
  },
  schoolRoll_deny: {
    /*
     * 教务拒绝
     * id id (integer query required)
     * reason 拒绝理由 (string query required)
     */
    put: (p, c) => $.put("/api/ems/education/schoolRoll/deny", p, c),
  },
  schoolRoll_checkExtraSixtyPayed: {
    /*
     * 临时-查询生成60元提成应发放时间
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/checkExtraSixtyPayed", p, c),
  },
  schoolRoll_batchPassByEducation: {
    /*
     * 批量教务审核通过-成教
     * ids ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/batchPassByEducation", p, c),
  },
  schoolRoll_assignEnrollTeacher: {
    /*
     * 奖励业绩
     * id id (integer query required)
     * enrollTeacherId 招生老师id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/assignEnrollTeacher", p, c),
  },
  schoolRoll_assignAdminTeacher: {
    /*
     * 分配合同负责人
     * id id (integer query required)
     * adminTeacherId 合同负责人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/schoolRoll/assignAdminTeacher", p, c),
  },
  schoolRoll_graduateCheck: {
    /*
     * 添加
     * check  ( query required)
     */
    post: (p, c) => $.post("/api/ems/education/schoolRoll/graduateCheck", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/schoolRoll/graduateCheck", p, c),
  },
  schoolRoll_graduateCheck_upload: {
    /*
     * 导入学生
     * id id (integer query required)
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/graduateCheck/upload", p, c),
  },
  schoolRoll_graduateCheck_publish: {
    /*
     * 发布
     * id id (integer query required)
     * publishStatus 状态 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/graduateCheck/publish", p, c),
  },
  schoolRoll_graduateCheck_confirm: {
    /*
     * 确认
     * id id (integer query required)
     * status 状态, 确认有误,确认无误 (string query required)
     * remark 选确认有误时, 填写有误内容说明 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/graduateCheck/confirm", p, c),
  },
  schoolRoll_graduateCheck_confirmForClient: {
    /*
     * c端确认
     * id id (integer query required)
     * status 状态, 确认有误,确认无误 (string query required)
     * remark 选确认有误时, 填写有误内容说明 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/graduateCheck/confirmForClient",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_uploadAdmission: {
    /*
     * 批量导入录取名单
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/exemptionDegree/uploadAdmission",
        p,
        c
      ),
  },
  schoolRoll_enrollNew: {
    /*
     * 报名
     * e  ( query required)
     */
    post: (p, c) => $.post("/api/ems/education/schoolRoll/enrollNew", p, c),
  },
  schoolRoll_enrollForClient: {
    /*
     * C端报名
     * e  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/enrollForClient", p, c),
  },
  schoolRoll_enrollEducationBySelf: {
    /*
     * 自考专本套读
     * id 合同id (integer query required)
     * batch 合同id (string query required)
     * majorId 专业id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/enrollEducationBySelf", p, c),
  },
  schoolRoll_enrollEducationByContinue: {
    /*
     * 成教报名（继教院）
     * enrollEducationByContinue  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/enrollEducationByContinue", p, c),
  },
  schoolRoll_batchUpdateForSuspend: {
    /*
     * 批量编辑休学学生
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/batchUpdateForSuspend", p, c),
  },
  schoolRoll_batchEnrollEducationByContinue: {
    /*
     * 批量成教报名（继教院）
     * batch 批次 (string query required)
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRoll/batchEnrollEducationByContinue",
        p,
        c
      ),
  },
  schoolRoll_batchChangeAdminTeacher: {
    /*
     * 批量修改合同负责人
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/batchChangeAdminTeacher", p, c),
  },
  schoolRoll_autoCheckDelayCommitted: {
    /*
     * 测试-定时任务合同成交超过7天未提交资料
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRoll/autoCheckDelayCommitted", p, c),
  },
  schoolRoll_listSourceFrom: {
    /*
     * 来源详情列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listSourceFrom", p, c),
  },
  schoolRoll_listSimpleByUserId: {
    /*
     * 简易学籍列表
     * userId 用户id (integer query )
     * schoolStatusList 学籍状态 (array query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listSimpleByUserId", p, c),
  },
  schoolRoll_listSettleAccount: {
    /*
     * 结算方列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listSettleAccount", p, c),
  },
  schoolRoll_listOldStudent: {
    /*
     * 老生列表
     * name 名字 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listOldStudent", p, c),
  },
  schoolRoll_listForXmtClue: {
    /*
     * 新媒体合同列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listForXmtClue", p, c),
  },
  schoolRoll_listForSuspendByService: {
    /*
     * 休学学生列表（服务）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForSuspendByService", p, c),
  },
  schoolRoll_listForSuspendByEducation: {
    /*
     * 休学学生列表（教务）
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForSuspendByEducation", p, c),
  },
  schoolRoll_listForNetClue: {
    /*
     * 网络合同列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listForNetClue", p, c),
  },
  schoolRoll_listForEnrollStatistics: {
    /*
     * 招生统计列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForEnrollStatistics", p, c),
  },
  schoolRoll_listForEnrollConfirm: {
    /*
     * 报名确认列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForEnrollConfirm", p, c),
  },
  schoolRoll_listForDepartmentEnroll: {
    /*
     * 部门合同列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/listForDepartmentEnroll", p, c),
  },
  schoolRoll_listForAiClue: {
    /*
     * AI营销合同列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listForAiClue", p, c),
  },
  schoolRoll_listExemptionDegreeForEducationConfirm: {
    /*
     * 资料审核列表（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/listExemptionDegreeForEducationConfirm",
        p,
        c
      ),
  },
  schoolRoll_listEnrollInfo: {
    /*
     * 获取学生报名信息
     * name 姓名 (string query )
     * phone 手机 (string query )
     * idCardNo 身份证 (string query )
     * siteType 学校类型 (string query )
     * schoolStatuses 学籍状态 (array query )
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listEnrollInfo", p, c),
  },
  schoolRoll_listCertificateForEducationConfirm: {
    /*
     * 资料审核列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/listCertificateForEducationConfirm",
        p,
        c
      ),
  },
  schoolRoll_listAdminRemark: {
    /*
     * 负责人备注列表
     * id 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/listAdminRemark", p, c),
  },
  schoolRoll_graduateCheck_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/list", p, c),
  },
  schoolRoll_graduateCheck_listSimple: {
    /*
     * 简易毕业信息核对列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/listSimple", p, c),
  },
  schoolRoll_graduateCheck_listForClient: {
    /*
     * c端, 查询毕业信息核对列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/listForClient", p, c),
  },
  schoolRoll_graduateCheck_listDetail: {
    /*
     * 核对详情列表-教学教务
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/listDetail", p, c),
  },
  schoolRoll_graduateCheck_listDetailForService: {
    /*
     * 核对详情列表-服务管理
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/graduateCheck/listDetailForService",
        p,
        c
      ),
  },
  schoolRoll_graduateCheck_exportDetail: {
    /*
     * 导出详情列表-教学教务
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/exportDetail", p, c),
  },
  schoolRoll_graduateCheck_exportDetailForService: {
    /*
     * 导出详情列表-服务管理
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/graduateCheck/exportDetailForService",
        p,
        c
      ),
  },
  schoolRoll_graduateCheck_downloadMould: {
    /*
     * 下载导入学生模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/graduateCheck/downloadMould", p, c),
  },
  schoolRoll_getSchoolRollIdByPhoneAndBatch: {
    /*
     * 根据手机号和批次获取学籍id
     * batch 批次 (string query required)
     * phone 手机号 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/getSchoolRollIdByPhoneAndBatch",
        p,
        c
      ),
  },
  schoolRoll_getOtherSchoolRollId: {
    /*
     * 查询其他合同数量列表
     * schoolRollId schoolRollId (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/getOtherSchoolRollId", p, c),
  },
  schoolRoll_getFrontAgreementInfo: {
    /*
     * 获取录取前报读须知内容
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/getFrontAgreementInfo", p, c),
  },
  schoolRoll_getAgreementInfo: {
    /*
     * 获取正式报读协议内容
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/getAgreementInfo", p, c),
  },
  schoolRoll_exportForXmtClue: {
    /*
     * 新媒体合同列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exportForXmtClue", p, c),
  },
  schoolRoll_exportForSuspend: {
    /*
     * 休学学生列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exportForSuspend", p, c),
  },
  schoolRoll_exportForNetClue: {
    /*
     * 网络合同列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exportForNetClue", p, c),
  },
  schoolRoll_exportForEnrollStatistics: {
    /*
     * 招生统计列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exportForEnrollStatistics", p, c),
  },
  schoolRoll_exportForDepartmentEnroll: {
    /*
     * 部门合同列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exportForDepartmentEnroll", p, c),
  },
  schoolRoll_exportForAiClue: {
    /*
     * AI营销合同列表导出
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/exportForAiClue", p, c),
  },
  schoolRoll_exportExemptionDegreeForEducationConfirm: {
    /*
     * 资料审核列表导出（免试专升本）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exportExemptionDegreeForEducationConfirm",
        p,
        c
      ),
  },
  schoolRoll_exportCertificateForEducationConfirm: {
    /*
     * 资料审核列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exportCertificateForEducationConfirm",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_listUnAssign: {
    /*
     * 未分配学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exemptionDegree/listUnAssign", p, c),
  },
  schoolRoll_exemptionDegree_listForService: {
    /*
     * 服务学生列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/listForService",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_listForAudit: {
    /*
     * 招办审核列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/exemptionDegree/listForAudit", p, c),
  },
  schoolRoll_exemptionDegree_exportForService: {
    /*
     * 服务学生列表导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/exportForService",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_exportForAudit: {
    /*
     * 招办审核导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/exportForAudit",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_downloadMouldForAdmission: {
    /*
     * 下载批量导入录取名单模版(免试专升本)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/downloadMouldForAdmission",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_detailsForService: {
    /*
     * 后端详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/detailsForService",
        p,
        c
      ),
  },
  schoolRoll_exemptionDegree_detailsForFront: {
    /*
     * 前端详情（报名确认、招生统计、招办审核）
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/exemptionDegree/detailsForFront",
        p,
        c
      ),
  },
  schoolRoll_downloadAdminTeacherModule: {
    /*
     * 批量修改合同负责人模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/downloadAdminTeacherModule", p, c),
  },
  schoolRoll_detailsForService: {
    /*
     * 学籍合同详情
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/detailsForService", p, c),
  },
  schoolRoll_detailsForServiceByClient: {
    /*
     * 学籍合同详情-企微端获取
     * externalUserId externalUserId (string query required)
     * platform 平台，默认可以不传，中军企微传入中军职达 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/detailsForServiceByClient", p, c),
  },
  schoolRoll_detailsForFront: {
    /*
     * 前端学籍合同详情（报名确认、招生统计、招办审核）
     * id id (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/schoolRoll/detailsForFront", p, c),
  },
  schoolRoll_countUnFinishForEnrollStatistics: {
    /*
     * 未补齐资料学生数量
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/countUnFinishForEnrollStatistics",
        p,
        c
      ),
  },
  schoolRoll_countOverdueForEnrollStatistics: {
    /*
     * 补齐资料逾期学生数量
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRoll/countOverdueForEnrollStatistics",
        p,
        c
      ),
  },
  schoolRoll_countForSuspendByService: {
    /*
     * 休学学生人数（教务）
     * type 类型:0即将逾期，1已逾期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/countForSuspendByService", p, c),
  },
  schoolRoll_countForSuspendByEducation: {
    /*
     * 休学学生人数（教务）
     * type 类型:0即将逾期，1已逾期 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/countForSuspendByEducation", p, c),
  },
  schoolRoll_countDelayCommitted: {
    /*
     * 成交超7天未提交资料审核
     * batch batch (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/countDelayCommitted", p, c),
  },
  schoolRoll_broadcastByContractId: {
    /*
     * 按合同号触发播报（仅超管可用）
     * contractId 合同ID（学籍ID） (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/broadcastByContractId", p, c),
  },
  schoolRoll_birthdayTodayForFront: {
    /*
     * 当天生日学生数量
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRoll/birthdayTodayForFront", p, c),
  },
  schoolRoll_graduateCheck_removeDetail: {
    /*
     * 删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete(
        "/api/ems/education/schoolRoll/graduateCheck/removeDetail",
        p,
        c
      ),
  },

  /**
   * 成教预毕业
   */
  previewGraduate_updateGraduateAppendInfo: {
    /*
     * 编辑毕业登记表
     * id id (integer query required)
     * formerName 曾用名 (string query )
     * nativePlace 籍贯 (string query )
     * workPlace 工作单位 (string query )
     * workDuty 现任职务、职称 (string query )
     * educationLevel 文化程度 (string query )
     * workStatus 职业状况(在职或离职) (string query )
     * highestLevelTime 入学前最高学历(年月日) (string query )
     * joinWorkTime 参加工作时间 (string query )
     * politicalStatus 政治面貌 (string query )
     * familyAddress 家庭住址 (string query )
     * familyPhone 家庭电话 (string query )
     * postcode 邮编 (string query )
     * rewards 奖惩情况 (string query )
     * selfAppraise 自我鉴定 (string query )
     * joinPartyInfo 何时何地何人介绍参加共产党员或共青团 (string query )
     * mainSocialRelations 主要社会关系 (string query )
     * selfSignatureUrl 学生签名地址 (string query )
     * healthInfo 健康状况 (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/previewGraduate/updateGraduateAppendInfo",
        p,
        c
      ),
  },
  previewGraduate_updateGraduateAppendInfoForClient: {
    /*
     * 编辑毕业登记表
     * id id (integer query required)
     * formerName 曾用名 (string query )
     * nativePlace 籍贯 (string query )
     * workPlace 工作单位 (string query )
     * workDuty 现任职务、职称 (string query )
     * educationLevel 文化程度 (string query )
     * workStatus 职业状况(在职或离职) (string query )
     * highestLevelTime 入学前最高学历(年月日) (string query )
     * joinWorkTime 参加工作时间 (string query )
     * politicalStatus 政治面貌 (string query )
     * familyAddress 家庭住址 (string query )
     * familyPhone 家庭电话 (string query )
     * postcode 邮编 (string query )
     * rewards 奖惩情况 (string query )
     * selfAppraise 自我鉴定 (string query )
     * joinPartyInfo 何时何地何人介绍参加共产党员或共青团 (string query )
     * mainSocialRelations 主要社会关系 (string query )
     * selfSignatureUrl 学生签名地址 (string query )
     * healthInfo 健康状况 (string query )
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/previewGraduate/updateGraduateAppendInfoForClient",
        p,
        c
      ),
  },
  previewGraduate_teacherAudit: {
    /*
     * 班主任审核毕业登记表
     * ids id列表 (array query required)
     * type 类型 1通过 2拒绝 (integer query required)
     * reason 通过则填写评语， 拒绝填写理由 (string query required)
     * signatureUrl 班主任签名地址 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/previewGraduate/teacherAudit", p, c),
  },
  previewGraduate_saveGraduateAppendInfoForClient: {
    /*
     * 添加毕业登记表
     * formerName 曾用名 (string query )
     * nativePlace 籍贯 (string query )
     * workPlace 工作单位 (string query )
     * workDuty 现任职务、职称 (string query )
     * joinWorkTime 参加工作时间 (string query )
     * educationLevel 文化程度 (string query )
     * workStatus 职业状况(在职或离职) (string query )
     * highestLevelTime 入学前最高学历(年月日) (string query )
     * politicalStatus 政治面貌 (string query )
     * familyAddress 家庭住址 (string query )
     * familyPhone 家庭电话 (string query )
     * postcode 邮编 (string query )
     * rewards 奖惩情况 (string query )
     * selfAppraise 自我鉴定 (string query )
     * joinPartyInfo 何时何地何人介绍参加共产党员或共青团 (string query )
     * mainSocialRelations 主要社会关系 (string query )
     * selfSignatureUrl 学生签名地址 (string query )
     * healthInfo 健康状况 (string query )
     * siteType siteType (string query required)
     */
    put: (p, c) =>
      $.put(
        "/api/ems/education/previewGraduate/saveGraduateAppendInfoForClient",
        p,
        c
      ),
  },
  previewGraduate_eduAudit: {
    /*
     * 教务审核毕业登记表信息
     * ids id列表 (array query required)
     * type 类型 1通过 2拒绝 (integer query required)
     * reason 通过则填写函授站意见， 拒绝填写理由 (string query )
     */
    put: (p, c) => $.put("/api/ems/education/previewGraduate/eduAudit", p, c),
  },
  previewGraduate_uploadThesisScore: {
    /*
     * 批量导入论文成绩
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/uploadThesisScore", p, c),
  },
  previewGraduate_uploadForExportDetailInfo: {
    /*
     * 按模板导出毕业登记表
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/previewGraduate/uploadForExportDetailInfo",
        p,
        c
      ),
  },
  previewGraduate_updateThesisScore: {
    /*
     * 批量修改论文成绩
     * ids 行ID列表 (array query required)
     * thesisScore 论文成绩（优秀良好不及格等） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/updateThesisScore", p, c),
  },
  previewGraduate_exportAppendInfo: {
    /*
     * 导出毕业登记表
     * ids 学籍ID列表 (array query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/exportAppendInfo", p, c),
  },
  previewGraduate_exportAppendInfoForEnterSchool: {
    /*
     * 导出入学登记表
     * ids 学籍ID列表 (array query required)
     * createTime 填表时间 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/previewGraduate/exportAppendInfoForEnterSchool",
        p,
        c
      ),
  },
  previewGraduate_createGraduateInfo: {
    /*
     * 生成预毕业名单
     * siteType 学校类型 (string query required)
     * wantGraduateDate 预计毕业时间（每月6月30号） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/createGraduateInfo", p, c),
  },
  previewGraduate_confirmStudyCertificateStatus: {
    /*
     * 批量确认学信网图像
     * ids 行ID列表 (array query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/previewGraduate/confirmStudyCertificateStatus",
        p,
        c
      ),
  },
  previewGraduate_checkGraduatePhoto: {
    /*
     * 刷新毕业照片
     * wantGraduateDate 预计毕业时间（每月6月30号） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/checkGraduatePhoto", p, c),
  },
  previewGraduate_auditGraduate: {
    /*
     * 毕业审核
     * wantGraduateDate 预计毕业时间（每月6月30号） (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/previewGraduate/auditGraduate", p, c),
  },
  previewGraduate_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/previewGraduate/list", p, c),
  },
  previewGraduate_getStudentBaseInfoChecking: {
    /*
     * 获取毕业生基本信息
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/previewGraduate/getStudentBaseInfoChecking",
        p,
        c
      ),
  },
  previewGraduate_getGraduateAppendInfo: {
    /*
     * 获取毕业登记表信息
     * schoolRollId schoolRollId (integer query )
     * siteType siteType (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/previewGraduate/getGraduateAppendInfo", p, c),
  },
  previewGraduate_export: {
    /*
     * 毕业审核结论导出-成教
     */
    get: (p, c) => $.get("/api/ems/education/previewGraduate/export", p, c),
  },
  previewGraduate_exportGraduateStudent: {
    /*
     * 导出毕业生名册
     * siteId 学校ID (integer query required)
     * wantGraduateDate 预计毕业时间（每年6月30号） (string query required)
     * graduateStatus 毕业状态：全部（不传）|未知|预毕业|不毕业 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/previewGraduate/exportGraduateStudent", p, c),
  },
  previewGraduate_downloadThesisScoreMould: {
    /*
     * 下载批量导入论文成绩模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/previewGraduate/downloadThesisScoreMould",
        p,
        c
      ),
  },

  /**
   * 照片采集
   */
  photoCollection_uploadPhoto: {
    /*
     * 上传照片
     * id 行id (integer query required)
     * chsiCollectCode 学信网采集码 (string query )
     * photoUrl 照片地址 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/uploadPhoto", p, c),
  },
  photoCollection_uploadPhotoForClient: {
    /*
     * 上传照片
     * id 行id (integer query required)
     * chsiCollectCode 学信网采集码 (string query required)
     * photoUrl 照片地址 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/uploadPhotoForClient", p, c),
  },
  photoCollection_uploadChsiPhotoOrCode: {
    /*
     * 导入学信网截图或学信网采集码（前端批量导入，身份证或学号命名）
     * type 类型： 1学信网截图 2学信网采集码 (integer query required)
     * batch 拍摄批次 (string query required)
     * idCardNo 身份证号码或学号 (string query required)
     * url 照片地址 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/uploadChsiPhotoOrCode", p, c),
  },
  photoCollection_setCampusAndClassRoom: {
    /*
     * 设置拍摄校区和拍摄教室
     * id 照片采集id (integer query required)
     * photoCampus 拍摄校区 (string query required)
     * classRoom 照片采集教室 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/setCampusAndClassRoom", p, c),
  },
  photoCollection_setAbleBatch: {
    /*
     * 设置启用批次
     * batches 启用批次 (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/setAbleBatch", p, c),
  },
  photoCollection_saveHeaderTeacherRemark: {
    /*
     * 添加班主任备注
     * id 照片采集id (integer query required)
     * eduRemark 备注内容 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/saveHeaderTeacherRemark", p, c),
  },
  photoCollection_saveEduRemark: {
    /*
     * 添加教务备注
     * id 照片采集id (integer query required)
     * eduRemark 备注内容 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/saveEduRemark", p, c),
  },
  photoCollection_auditByHeaderTeacher: {
    /*
     * 班主任审核
     * id id (integer query required)
     * auditStatus 审核状态 (string query required)
     * remark 审核备注 (string query )
     * photoUrl 审核照片 (string query required)
     * chsiCollectCode 审核照片 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/auditByHeaderTeacher", p, c),
  },
  photoCollection_auditByEducation: {
    /*
     * 教务审核
     * ids 行ids (array query )
     * auditStatus 审核状态 (string query required)
     * remark 审核备注 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/education/photoCollection/auditByEducation", p, c),
  },
  photoCollection: {
    /*
     * 添加编辑
     * photoCollection  ( query required)
     */
    post: (p, c) => $.post("/api/ems/education/photoCollection", p, c),
  },
  photoCollection_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/education/photoCollection/upload", p, c),
  },
  photoCollection_uploadEduAdult: {
    /*
     * 教务导入审核
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/uploadEduAdult", p, c),
  },
  photoCollection_uploadArrange: {
    /*
     * 导入采集安排
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/uploadArrange", p, c),
  },
  photoCollection_syncSchoolRoll: {
    /*
     * 同步学籍
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/syncSchoolRoll", p, c),
  },
  photoCollection_batchUpdate: {
    /*
     * 照片采集批量更新
     * batch 拍摄批次 (string query required)
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/photoCollection/batchUpdate", p, c),
  },
  photoCollection_searchForClient: {
    /*
     * C端查询我的图片采集信息
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/searchForClient", p, c),
  },
  photoCollection_listForService: {
    /*
     * 服务列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/listForService", p, c),
  },
  photoCollection_listForEducation: {
    /*
     * 教务列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/listForEducation", p, c),
  },
  photoCollection_listColumn: {
    /*
     * 字段列表
     * column 列名称 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/listColumn", p, c),
  },
  photoCollection_getSimple: {
    /*
     * 根据身份证和拍摄批次获取学生拍照信息
     * batch 拍照批次 (string query required)
     * idCardNo 身份证 (string query required)
     * photoCampus 拍摄小区 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/getSimple", p, c),
  },
  photoCollection_getNext: {
    /*
     * 下个学生拍摄信息
     * batch 拍摄批次 (string query required)
     * photoCampus 拍摄校区 (string query required)
     * classRoom 拍摄教室 (string query required)
     * sequenceNo 序号，不传则取序号1的 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/getNext", p, c),
  },
  photoCollection_getId: {
    /*
     * 根据身份证和拍摄批次获取学生拍照信息
     * batch 拍照批次 (string query required)
     * idCardNo 身份证 (string query )
     * studentNo 学号 (string query )
     * photoCampus 拍摄小区 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/photoCollection/getId", p, c),
  },
  photoCollection_getAbleBatch: {
    /*
     * 获取启用批次
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/getAbleBatch", p, c),
  },
  photoCollection_exportForEducation: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/exportForEducation", p, c),
  },
  photoCollection_downloadUpdateModule: {
    /*
     * 批量更新模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/downloadUpdateModule", p, c),
  },
  photoCollection_downloadMouldForAudit: {
    /*
     * 下载教务导入审核模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/photoCollection/downloadMouldForAudit", p, c),
  },
  photoCollection_batchRemove: {
    /*
     * 批量删除
     * ids 行id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/photoCollection/batchRemove", p, c),
  },

  /**
   * 同行学生
   */
  peer_updateForFront: {
    /*
     * 招生老师编辑
     * sr  ( query required)
     */
    put: (p, c) => $.put("/api/ems/education/peer/updateForFront", p, c),
  },
  peer_pass: {
    /*
     * 招生老师通过
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/peer/pass", p, c),
  },
  peer_uploadUpdateAdultInfo: {
    /*
     * 批量更新成考信息
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/peer/uploadUpdateAdultInfo", p, c),
  },
  peer_uploadPeerStudent: {
    /*
     * 批量代报
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/education/peer/uploadPeerStudent", p, c),
  },
  peer_uploadForUpdateService: {
    /*
     * 批量导入更新服务信息
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/peer/uploadForUpdateService", p, c),
  },
  peer_batchUpdatePeerStudent: {
    /*
     * 批量编辑
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/peer/batchUpdatePeerStudent", p, c),
  },
  peer_listForEnrollConfirm: {
    /*
     * 报名确认列表
     */
    get: (p, c) => $.get("/api/ems/education/peer/listForEnrollConfirm", p, c),
  },
  peer_exportForEnrollConfirm: {
    /*
     * 报名确认列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/exportForEnrollConfirm", p, c),
  },
  peer_downloadUpdateServiceMould: {
    /*
     * 批量导入更新服务信息模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadUpdateServiceMould", p, c),
  },
  peer_downloadUpdateAdultInfo: {
    /*
     * 批量更新成考信息模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadUpdateAdultInfo", p, c),
  },
  peer_downloadPeerStudentMould: {
    /*
     * 批量代报模版
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadPeerStudentMould", p, c),
  },
  peer_downloadBatchUpdatePeerStudentMould: {
    /*
     * 批量编辑模版
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/peer/downloadBatchUpdatePeerStudentMould",
        p,
        c
      ),
  },
  peer_downloadBatchChangeMajorMould: {
    /*
     * 批量导入更换批次专业模板
     */
    get: (p, c) =>
      $.get("/api/ems/education/peer/downloadBatchChangeMajorMould", p, c),
  },
  peer_details: {
    /*
     * 前端学籍合同详情（报名确认、招生统计、招办审核）
     * id id (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/peer/details", p, c),
  },
  peer_analysisLearnForm: {
    /*
     * 解析学习形式
     * batch 批次 (string query )
     * rollGrade 学籍年级 (string query )
     * adultExamYear 成考年度 (string query )
     * level 专业层次 (string query )
     * siteType 学校类型 (string query )
     * site 学校 (string query )
     * major 专业 (string query )
     * schoolStatuses 学籍状态 (array query )
     */
    get: (p, c) => $.get("/api/ems/education/peer/analysisLearnForm", p, c),
  },

  /**
   * 在线承诺书签署
   */
  online_signature_uploadSignature: {
    /*
     * C端上传签署书（签名）
     * recordId 记录id (integer query required)
     * indexColumnValue 唯一索引值 (string query required)
     * signData 签名图片，png文件，base64值 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/online/signature/uploadSignature", p, c),
  },
  online_signature_editInfoStruct: {
    /*
     * 信息数据结构
     * id id (integer query required)
     * infoStruct 信息数据结构 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/education/online/signature/editInfoStruct", p, c),
  },
  online_signature: {
    /*
     * 添加
     * onlineSignature  ( query required)
     */
    post: (p, c) => $.post("/api/ems/education/online/signature", p, c),

    /*
     * 删除
     * id Id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/education/online/signature", p, c),
  },
  online_signature_uploadRecord: {
    /*
     * 上传记录
     * id 记录id (integer query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/online/signature/uploadRecord", p, c),
  },
  online_signature_addOrEditRecord: {
    /*
     * 添加编辑记录
     * id id (integer query required)
     * body 信息 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/online/signature/addOrEditRecord", p, c),
  },
  online_signature_listRecord: {
    /*
     * 记录列表
     * id 记录id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/online/signature/listRecord", p, c),
  },
  online_signature_listAdult: {
    /*
     * 列表（学历教育）
     */
    get: (p, c) => $.get("/api/ems/education/online/signature/listAdult", p, c),
  },
  online_signature_infoStruct: {
    /*
     * 信息数据结构
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/online/signature/infoStruct", p, c),
  },
  online_signature_getInfo: {
    /*
     * 根据类型获取签署内容
     * recordId 记录id (integer query required)
     * indexColumnValue 唯一索引值 (string query required)
     */
    get: (p, c) => $.get("/api/ems/education/online/signature/getInfo", p, c),
  },
  online_signature_exportRecord: {
    /*
     * 导出记录
     * id 记录id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/online/signature/exportRecord", p, c),
  },
  online_signature_removeRecord: {
    /*
     * 删除记录
     * id id (integer query required)
     * indexColumnValues 索引值 (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/online/signature/removeRecord", p, c),
  },

  /**
   * 修改转介绍信息
   */
  changeReferral_sync: {
    /*
     * 同步
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/education/changeReferral/sync", p, c),
  },
  changeReferral_apply: {
    /*
     * 申请
     * schoolRollId 学籍id (integer query required)
     * referralUserId 推荐人id (integer query required)
     * remark 备注 (string query required)
     * dingDepartmentId 钉钉部门id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/education/changeReferral/apply", p, c),
  },
  changeReferral_listBySchoolRollId: {
    /*
     * 当前合同下的修改转介绍记录列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/changeReferral/listBySchoolRollId", p, c),
  },

  /**
   * 前置学历待查
   */
  schoolRollChecking_schoolAudit: {
    /*
     * 高校审核
     * id ID (integer query required)
     * type 类型 1通过 2拒绝 (integer query required)
     * refuseReason 拒绝理由 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/schoolAudit", p, c),
  },
  schoolRollChecking_saveReason: {
    /*
     * 保存待查原因
     * id ID (integer query required)
     * reason 待查原因(下拉 + 其他手填) (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/saveReason", p, c),
  },
  schoolRollChecking_saveFileUrl: {
    /*
     * 保存审核资料
     * id ID (integer query required)
     * extraFileUrl 资料压缩文件地址 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/saveFileUrl", p, c),
  },
  schoolRollChecking_refresh: {
    /*
     * 刷新数据
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/refresh", p, c),
  },
  schoolRollChecking_eduAudit: {
    /*
     * 教务审核
     * id ID (integer query required)
     * type 类型 1通过 2拒绝 (integer query required)
     * refuseReason 拒绝理由 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollChecking/eduAudit", p, c),
  },
  schoolRollChecking_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/schoolRollChecking/list", p, c),
  },

  /**
   * 待异动库
   */
  schoolRollBatchTransaction_upload: {
    /*
     * 批量导入异动合同
     * id 行ID (integer query )
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollBatchTransaction/upload", p, c),
  },
  schoolRollBatchTransaction_save: {
    /*
     * 添加编辑
     * id ID (integer query )
     * name 名称 (string query required)
     * deadline 截止时间 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/schoolRollBatchTransaction/save", p, c),
  },
  schoolRollBatchTransaction_addSchoolRoll: {
    /*
     * 添加异动合同
     * id ID (integer query )
     * schoolRollId 合同编号 (integer query )
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/schoolRollBatchTransaction/addSchoolRoll",
        p,
        c
      ),
  },
  schoolRollBatchTransaction_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollBatchTransaction/list", p, c),
  },
  schoolRollBatchTransaction_listRecord: {
    /*
     * 详情
     * id ID (integer query required)
     * siteId 学校ID (integer query )
     * batch 批次 (string query )
     * schoolRollId 合同编号 (integer query )
     * name 学生姓名 (string query )
     * adminTeacherId 合同负责人 (integer query )
     * finishStatus 是否已异动， 是否 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollBatchTransaction/listRecord", p, c),
  },
  schoolRollBatchTransaction_listForAdminTeacher: {
    /*
     * 招生管理-待异动库-列表
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollBatchTransaction/listForAdminTeacher",
        p,
        c
      ),
  },
  schoolRollBatchTransaction_export: {
    /*
     * 导出
     * id ID (integer query required)
     * siteId 学校ID (integer query )
     * batch 批次 (string query )
     * schoolRollId 合同编号 (integer query )
     * name 学生姓名 (string query )
     * adminTeacherId 合同负责人 (integer query )
     * finishStatus 是否已异动， 是否 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/schoolRollBatchTransaction/export", p, c),
  },
  schoolRollBatchTransaction_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/schoolRollBatchTransaction/downloadMould",
        p,
        c
      ),
  },
  schoolRollBatchTransaction_remove: {
    /*
     * 删除
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/education/schoolRollBatchTransaction/remove", p, c),
  },
  schoolRollBatchTransaction_removeSchoolRoll: {
    /*
     * 删除异动合同
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete(
        "/api/ems/education/schoolRollBatchTransaction/removeSchoolRoll",
        p,
        c
      ),
  },

  /**
   * 同行成教名单
   */
  peerAdultRoster: {
    /*
     * 添加
     * roster  ( query required)
     */
    post: (p, c) => $.post("/api/ems/education/peerAdultRoster", p, c),

    /*
     * 删除
     * ids ids (array query required)
     */
    delete: (p, c) => $.delete("/api/ems/education/peerAdultRoster", p, c),
  },
  peerAdultRoster_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/ems/education/peerAdultRoster/upload", p, c),
  },
  peerAdultRoster_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/peerAdultRoster/list", p, c),
  },
  peerAdultRoster_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/peerAdultRoster/export", p, c),
  },

  /**
   * 免试专升本排课（新）
   */
  mszsb_timetable: {
    /*
     * 添加编辑
     * id id (integer query )
     * name 名称 (string query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     * remark 备注 (string query )
     */
    post: (p, c) => $.post("/api/ems/education/mszsb/timetable", p, c),
  },
  mszsb_timetableDetail_updateInfo: {
    /*
     * 编辑
     * id id (integer query required)
     * courseId 课程id (integer query required)
     * teacherId 教师id (integer query required)
     * displayName 显示名称 (string query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     * remark 备注 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/education/mszsb/timetableDetail/updateInfo", p, c),
  },
  mszsb_timetable_updateScheduleTimeContent: {
    /*
     * 配置上课具体时间
     * id id (integer query )
     * timeContent Json序列化之后的字符串 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/mszsb/timetable/updateScheduleTimeContent",
        p,
        c
      ),
  },
  mszsb_timetable_updateScheduleTeacherContent: {
    /*
     * 配置上课老师
     * id id (integer query required)
     * timeContent Json序列化之后的字符串 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/mszsb/timetable/updateScheduleTeacherContent",
        p,
        c
      ),
  },
  mszsb_timetable_updateScheduleCourseContent: {
    /*
     * 配置上课课程内容
     * id id (integer query required)
     * timeContent Json序列化之后的字符串 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/education/mszsb/timetable/updateScheduleCourseContent",
        p,
        c
      ),
  },
  mszsb_timetable_updateBasicTimeContent: {
    /*
     * 配置的基础上课节数或全局基础上课节数， id不传为全局
     * id id (integer query )
     * timeContent Json序列化之后的字符串 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/mszsb/timetable/updateBasicTimeContent", p, c),
  },
  mszsb_timetable_schedule: {
    /*
     * 排课
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/education/mszsb/timetable/schedule", p, c),
  },
  mszsb_timetable_publish: {
    /*
     * 发布
     * id id (integer query required)
     * publishStatus 发布状态 (string query required)
     */
    post: (p, c) => $.post("/api/ems/education/mszsb/timetable/publish", p, c),
  },
  mszsb_timetable_clearSchedule: {
    /*
     * 清空排课
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/education/mszsb/timetable/clearSchedule", p, c),
  },
  mszsb_timetableDetail_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/mszsb/timetableDetail/list", p, c),
  },
  mszsb_timetableDetail_listForClient: {
    /*
     * c端我的课表
     */
    get: (p, c) =>
      $.get("/api/ems/education/mszsb/timetableDetail/listForClient", p, c),
  },
  mszsb_timetableDetail_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/mszsb/timetableDetail/export", p, c),
  },
  mszsb_timetable_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/mszsb/timetable/list", p, c),
  },
  mszsb_timetable_listSimple: {
    /*
     * 简易列表
     * publishStatus 发布状态 (string query )
     */
    get: (p, c) => $.get("/api/ems/education/mszsb/timetable/listSimple", p, c),
  },
  mszsb_timetable_listSimpleBasicPeriods: {
    /*
     * 简易上课节数列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/mszsb/timetable/listSimpleBasicPeriods", p, c),
  },
  mszsb_timetable_listScheduleTimeContent: {
    /*
     * 查询配置的上课具体时间
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/education/mszsb/timetable/listScheduleTimeContent", p, c),
  },
  mszsb_timetable_listScheduleTeacherContent: {
    /*
     * 查询配置的上课老师
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/mszsb/timetable/listScheduleTeacherContent",
        p,
        c
      ),
  },
  mszsb_timetable_listScheduleResult: {
    /*
     * 查看排课结果
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/mszsb/timetable/listScheduleResult", p, c),
  },
  mszsb_timetable_listScheduleCourseContent: {
    /*
     * 查询配置的上课课程内容
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/ems/education/mszsb/timetable/listScheduleCourseContent",
        p,
        c
      ),
  },
  mszsb_timetable_listBasicTimeContent: {
    /*
     * 查询配置的基础上课节数或全局基础上课节数， id不传为全局
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/mszsb/timetable/listBasicTimeContent", p, c),
  },
  mszsb_timetable_getScheduleDetail: {
    /*
     * 查看课表
     * id id (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/education/mszsb/timetable/getScheduleDetail", p, c),
  },

  /**
   * 学习记录
   */
  study_record_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/study/record/list", p, c),
  },
  study_record_listForSiteAudit: {
    /*
     * 列表（审计）
     */
    get: (p, c) =>
      $.get("/api/ems/education/study/record/listForSiteAudit", p, c),
  },
  study_record_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/study/record/export", p, c),
  },
  study_record_exportForSiteAudit: {
    /*
     * 导出（审计）
     */
    get: (p, c) =>
      $.get("/api/ems/education/study/record/exportForSiteAudit", p, c),
  },
  study_record_exportDetail: {
    /*
     * 详情导出
     * term 学期 (integer query )
     */
    get: (p, c) => $.get("/api/ems/education/study/record/exportDetail", p, c),
  },
  study_record_detail: {
    /*
     * 详情
     * userId userId (integer query required)
     * courseId 课程ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/education/study/record/detail", p, c),
  },

  /**
   * 成教学生课程
   */
  studentCourse_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/education/studentCourse/list", p, c),
  },
  studentCourse_listForSiteAudit: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/ems/education/studentCourse/listForSiteAudit", p, c),
  },
  studentCourse_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/education/studentCourse/export", p, c),
  },
  studentCourse_exportForSiteAudit: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/education/studentCourse/exportForSiteAudit", p, c),
  },
};
